import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccesoService } from '../../acceso/acceso.service';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FileCloudService {

  readonly urlBase =  environment.rutaBase;
  header : HttpHeaders;

  constructor(private http: HttpClient ,  private accesoService :AccesoService) {
    this.header = this.accesoService.desencriptarTOKEN();
   }

  downloadFile(link){
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/configuraciones/obtener/archivo?file_Id=${link}`,{headers});
  } 

}
